// src/guards.js
import Swal from "sweetalert2";
import store from "./store/store";
import { abortAllRequests } from "./services/api/BASE_URL";

export const beforeEachGuard = async (to, from, next) => {
  abortAllRequests();
  const userId = store.getters["userSlice/userId"];
  const userRole = store.getters["userSlice/userRole"];
  const isAdmin = userRole == 1 || userId == 8;
  if (to.meta.requiresAuth) {
    if (store.getters["userSlice/isLogin"]) {
      //Handling /admin route permissions
      if (to.meta.requiresAdmin && !isAdmin) {
        await Swal.fire({
          icon: "error",
          title: "شما اجازه دسترسی به این صفحه را ندارید",
          text: "به صفحه لید ها منتقل میشوید...",
          showConfirmButton: false,
          timer: 1500,
        });
        console.log("You are not an admin, Redirecting to /leads ...");
        next("/leads");
      }
      next();
    } else {
      // Show Swal alert
      await Swal.fire({
        icon: "error",
        title: "شما اجازه دسترسی به این صفحه را ندارید",
        text: "به صفحه لاگین منتقل میشوید...",
        showConfirmButton: false,
        timer: 1500,
      });
      next("/login");
    }
  } else {
    next();
  }
};

export const afterEachGuard = async (to) => {
  store.commit("uiSlice/closeHamburgerMenu");
  const title = to.meta.title || "سی آر ام";
  document.title = title;
};
